import pushModel from "@/mixin/store/api/pushModel";
import fetchModel from "@/mixin/store/api/fetchModel";
import fetchModels from "@/mixin/store/api/fetchModels";
import axios from "@/plugins/axios";
import changeModel from "@/mixin/store/api/changeOrPushModel";

export default {
    actions: {
        pushKpi(context, data) {
            return pushModel(context, 'k_p_is', data, 'updateKpi')
        },
        putKpi(context, data) {
            return changeModel(context, 'k_p_is', data, 'updateKpi')
        },
        fetchKpis(context, search) {
                return fetchModels(context, 'k_p_is', search.page, 'updateKpis')
        },
        fetchKpi(context, id) {
                return fetchModel(context, 'k_p_is', id, 'updateKpi')
        },
        makeFinishKpi(context, data) {
            return changeModel(context, 'k_p_is', data, 'updateKpi')
        },
        fetchKpiStatus(context) {
            let url = 'k_p_is/status'

            return axios.get(url)
                .then((response) => {
                    console.log(response)
                    context.commit('updateKpi', response.data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        searchKpis(context, search) {
            let url = 'k_p_is?order[id]=desc'

            if (search.startAt) {
                url += '&startAt[after]=' + search.startAt
            }

            if (search.endAt) {
                url += '&endAt[before]=' + search.endAt
            }

            if (search.isOnlyActive) {
                url += '&isActive=true'
            }

            if (search.type !== 'all') {
                url += '&type=' + search.type
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateKpis', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        resetKpi(context, data) {
            return new Promise(((resolve, reject) => {
                axios.interceptors.request.use((config) => {
                    config.headers['Content-Type'] = 'application/ld+json'

                    return config
                })

                axios
                    .put('/k_p_is/' + data.id + '/change', data)
                    .then(response => {
                        context.commit('updateKpi', response.data)
                        resolve()
                    })
                    .catch(() => {
                        reject()
                    })
            }))
        }
    },
    mutations: {
        updateKpi(state, data) {
            state.kpi = data
            state.kpi.isNeedFetch = false
        },
        updateKpis(state, data) {
            state.kpis = data
            state.kpis.isNeedFetch = false
        },
    },
    state: {
        kpi: null,
        kpis: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
    },
    getters: {
        getKpi(state) {
            return state.kpi
        },
        getKpis(state) {
            return state.kpis.models
        },
        getKpisTotalCount(state) {
            return state.kpis.totalItems
        },
    },
}
